import React from "react";
import { useSelector } from "react-redux";
import useItemsGroupContext from "../../hooks/useItemsGroupContext";

import { Col, Icon, Row } from "antd";
import { CardCustom, Title } from "./styles";
import ButtonStandard from "../../components/utils/button";
import ItemsGroupForm from "./form";
import ItemsGroupTable from "./table";
import ItemsGroupClassify from "./classify";

const ItemsGroupLayout = () => {
  const { translation } = useSelector((state) => state.app);
  const { fetchData, openDrawer } = useItemsGroupContext();

  return (
    <CardCustom>
      <Row className="rowHeader" justify="space-between">
        <Col span={8}>
          <Title>{translation.itemsGroup.title}</Title>
        </Col>
        <Col span={16}>
          <Row type="flex" justify="end" gutter={8}>
            <Col>
              <ButtonStandard buttonType="typeWithoutBackground" onClick={fetchData}>
                <Icon type="reload" />
              </ButtonStandard>
            </Col>
            <Col>
              <ButtonStandard buttonType="addNew" onClick={() => openDrawer()}>
                {translation.itemsGroup.buttonNew}
              </ButtonStandard>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row type="flex">
        <Col span={24}>
          <ItemsGroupTable />
        </Col>
      </Row>
    </CardCustom>
  );
};

const ItemsGroup = () => (
  <>
    <ItemsGroupLayout />
    <ItemsGroupForm />
    <ItemsGroupClassify />
  </>
);

export default ItemsGroup;
